
export enum MessageHubEvent {
    GetActiveAlertsForUserComplete = 'GetActiveAlertsForUserComplete',
    ClientCreateStatus = "ClientCreateStatus",
    SyncStatus = "SyncStatus",
    AppointmentEntryWaitCountByLocation = "AppointmentEntryWaitCountByLocation",
    LoadLobbyEntryWaitCountByLocation = "LoadLobbyEntryWaitCountByLocation",
    ProvisionLogDisplay = "ProvisionLogDisplay",
    LoadSignalRSystemConfiguration = "LoadSignalRSystemConfiguration",
    LoadSignalRLocationSelectorStatus = "LoadSignalRLocationSelectorStatus",
    GetUserSignedInStatus = "GetUserSignedInStatus",
    GetStatBarDataComplete = "GetStatBarDataComplete",
    LoadSignalRStaffStatusGrid = "LoadSignalRStaffStatusGrid",
    GetSignedInUsersAndGroups = "GetSignedInUsersAndGroups",
    LoadSignalRLobbyStatusGrid = "LoadSignalRLobbyStatusGrid",
    LoadSignalRCentralStaffStatusGrid = "LoadSignalRCentralStaffStatusGrid",
    LoadSignalRCentralLobbyStatusGrid = "LoadSignalRCentralLobbyStatusGrid",
    LoadSignalRCentralBranchStatusGrid = "LoadSignalRCentralBranchStatusGrid",
    LoadSignalRMyAppointmentGrid = "LoadSignalRMyAppointmentGrid",
    LoadSignalRAppointmentGrid = "LoadSignalRAppointmentGrid"
}
